var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWaveform = function SvgWaveform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.569 8h.869l.056.438 2.581 19.768 2.431-13.787.075-.413h.806l.1.369 1.894 7.125H40v1h-4.381l-.1-.369L34.1 16.82l-2.606 14.769-.075.412h-.857l-.056-.437-2.537-19.438-3.475 23.45-.063.425h-.869l-.056-.437L20 8.406l-3.506 27.157-.056.437h-.87l-.062-.425-3.475-23.45-2.537 19.438-.056.437H8.58l-.075-.413L5.9 16.813l-1.419 5.312-.1.375H0v-1h3.619l1.9-7.131.1-.369h.806l.075.412L8.931 28.2l2.575-19.762.056-.438h.87l.062.425 3.469 23.431 3.543-27.418.056-.438h.875l.057.438 3.537 27.418 3.475-23.431z"
  })));
};
export default SvgWaveform;